<script>
import { navMixin } from '#/routes/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'RcSiteBannerCTA',
  mixins: [navMixin],

  computed: {
    ...mapGetters(['roleIsGuest', 'isAuthenticated']),

    hasBannerCTA() {
      return this.$route.meta.bannerCTA
    },
    typeCTA() {
      return this.$route.meta.bannerCTA.type
    },
    cssCTA() {
      return this.$route.meta.bannerCTA.cssClass
    },
    routeName() {
      return this.$route.name
    },
  },
}
</script>

<template>
  <div
    v-if="hasBannerCTA && (roleIsGuest || !isAuthenticated)"
    :class="cssCTA ? cssCTA : ''"
  >
    <transition name="fade" mode="out-in">
      <div v-if="typeCTA === 'subscription'">
        <div class="rc-banner-cta bg-teal">
          <div class="container">
            <div class="row flex-column-reverse flex-md-row">
              <div class="col-md-6 rc-col-max-width">
                <h2
                  v-if="routeName === 'market.channels'"
                  v-html="$t('footer.subscription.banner.title_channels')"
                />
                <h2 v-else v-html="$t('footer.subscription.banner.title')" />

                <router-link
                  :to="toMarketSubscriptionRequest"
                  class="btn btn-dark btn-xl mt-4"
                >
                  {{ $t("footer.subscription.banner.cta") }}
                </router-link>
              </div>
              <div class="col-md-6 col-xl-5 text-end">
                <div class="rc-wrapper-antelope" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="rc-banner-cta" :class="cssCTA">
          <div class="container">
            <div class="row flex-column-reverse flex-md-row">
              <div class="col-md-6 rc-col-max-width">
                <h2 v-html="$t('footer.get_started.banner.title')" />
                <p class="rc-intro--xl">
                  {{ $t("footer.get_started.banner.text") }}
                </p>
                <router-link :to="toLogin" class="btn btn-primary btn-lg">
                  {{ $t("footer.get_started.banner.cta") }}
                </router-link>
              </div>
              <div class="col-md-6 text-end">
                <div class="rc-wrapper-dolphin" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped></style>
